// extracted by mini-css-extract-plugin
module.exports = {"section":"MenuSection_section__NQuR_"};